exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".team-card-due-scroll-navigation__countContainer__1ozu8 {\n  align-items: center;\n  background-color: #E2E4E6;\n  border-radius: 18px;\n  display: flex;\n  font-size: 10px;\n  height: 16px;\n  justify-content: center;\n  min-width: 24px;\n}\n.team-card-due-scroll-navigation__selected__30LjL.team-card-due-scroll-navigation__countContainer__1ozu8 {\n  background-color: #298FCA;\n  color: white;\n}\n.team-card-due-scroll-navigation__cardDueTabButton__jVUSR {\n  margin-top: 4px;\n}\n.team-card-due-scroll-navigation__cardDueContainer__Kgeta:first-of-type .team-card-due-scroll-navigation__cardDueTabButton__jVUSR {\n  margin-top: 0;\n}\n", ""]);

// exports
exports.locals = {
	"countContainer": "team-card-due-scroll-navigation__countContainer__1ozu8",
	"selected": "team-card-due-scroll-navigation__selected__30LjL",
	"cardDueTabButton": "team-card-due-scroll-navigation__cardDueTabButton__jVUSR",
	"cardDueContainer": "team-card-due-scroll-navigation__cardDueContainer__Kgeta"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":2,"localIdentName":"[name]__[local]__[hash:base64:5]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-2133/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/scripts/views/home/presentational/team-card-due-scroll-navigation.less
// module id = iWgT
// module chunks = 1